// extracted by mini-css-extract-plugin
module.exports = {"seriesListWrapper":"oB","fullWidth":"oC","seriesListTabWrapper":"oD","tab":"oE","active":"oF"};